export enum PromotionChallengeLimitTypeEnum {
  ONCE = 'ONCE',
  UNLIMITED = 'UNLIMITED',
  PER_DAY = 'PER_DAY',
  PER_CAMPAIGN = 'PER_CAMPAIGN',
}
